import * as Toast from 'react-toast-notifications';
import { resolveErrorMessage } from 'helpers/parser';

export const useToasts = () => {
  const toasts = Toast.useToasts();

  return {
    errorToast: (message, params) => {
      if (message?.error) {
        const { error } = message;
        message = resolveErrorMessage(error, { defaultMessage: message.default });
        console.error(message, error);
      }
      return toasts.addToast(message, {
        ...params,
        appearance: 'error',
        autoDismissTimeout: 15000, // 15 sec
      });
    },
    warningToast: (message, params) =>
      toasts.addToast(message, {
        ...params,
        appearance: 'warning',
      }),
    successToast: (message, params) =>
      toasts.addToast(message, {
        ...params,
        appearance: 'success',
      }),
    ...toasts,
  };
};
